import { Component, OnInit } from '@angular/core';
import { MyPropertyService } from 'src/services/my-property';
import { MyPropertyModel } from 'src/model/my-property/my-property';
import { AuthenticationService } from '../_services/authentication.service';
import { Title } from '@angular/platform-browser';
import { CanonicalService } from '../shared/canonical.service';
import { NiceScrollService } from '../_services/nice-scroll.service';
// import { LoaderService } from '../_services/loader.service';
declare var $: any;

@Component({
    selector: 'app-my-properties',
    templateUrl: './my-properties.component.html',
    styleUrls: ['./my-properties.component.css'],
    providers: [MyPropertyModel],
    standalone: false
})
export class MyPropertiesComponent implements OnInit {
  UserFullName: string;
  ProfileImageUrl: string;
  ActiveCollection = { count: 0, data: [] };
  PendingCollection = { count: 0, data: [] };
  RejectedCollection = { count: 0, data: [] };
  SoldCollection = { count: 0, data: [] };
  activeProcessed = false;
  pendingProcessed = false;
  rejectedProcessed = false;
  soldProcessed = false;
  childLoad = false;
  constructor(
    private titleService: Title,
    private myPropertyService: MyPropertyService,
    private canonicalService: CanonicalService,
    private userService: AuthenticationService,
    private niceScroll: NiceScrollService
    ) {
    //  niceScroll.scrollToTop();
    }

  ngOnInit() {
    this.getActiveProperty();
    this.SetUserName();
    this.setTabs();
    this.titleService.setTitle(this.UserFullName + ' | Properties | Buy, Sell, Rent Homes & Properties in Pakistan | pakmatti.com');
    this.canonicalService.setCanonicalURL();
  }

  setTabs() {
    // tslint:disable-next-line: one-variable-per-declaration
    const $tabsNav = $('.tabs-nav'),
      $tabsNavLis = $tabsNav.children('li');
    $tabsNav.each(function() {
      const $this = $(this);
      $this.next().children('.tab-content').stop(true, true).hide().first().show();
      $this.children('li').first().addClass('active').stop(true, true).show();
    });
    $tabsNavLis.on('click', function(e) {
      // tslint:disable-next-line: prefer-const
      let $this = $(this);
      $this.siblings().removeClass('active').end().addClass('active');
      $this.parent().next().children('.tab-content').stop(true, true).hide().siblings($this.find('a').attr('href')).fadeIn();
      e.preventDefault();
    });
    const hash = window.location.hash;
    const anchor = $('.tabs-nav a[href="' + hash + '"]');
    if (anchor.length === 0) {
      $('.tabs-nav li:first').addClass('active').show();
      $('.tab-content:first').show();
    } else {
      anchor.parent('li').click();
    }
  }

  getActiveProperty() {
    // this.loader.showLoader();
    this.childLoad = true;
    this.myPropertyService.getActiveProperty().subscribe(activeProperty => {
      this.ActiveCollection.data = activeProperty;
      this.activeProcessed = true;
      // this.loader.hideLoader();
      this.childLoad = false;
    });
  }

  getPendingProperty() {
    this.childLoad = true;
    this.myPropertyService.getPendingProperty().subscribe(pendingProperty => {
      this.PendingCollection.data = pendingProperty;
      this.pendingProcessed = true;
      this.childLoad = false;
    });
  }

  getRejectedProperty() {
    this.childLoad = true;
    this.myPropertyService.getRejectedProperty().subscribe(rejectedProperty => {
      this.RejectedCollection.data = rejectedProperty;
      this.rejectedProcessed = true;
      this.childLoad = false;
    });
  }

  getSoldProperty() {
    this.childLoad = true;
    this.myPropertyService.getSoldProperty().subscribe(soldProperty => {
      this.SoldCollection.data = soldProperty;
      this.soldProcessed = true;
      this.childLoad = false;
    });
  }


  Logout() {
    //this.userService.logout();
  }



  SetUserName() {
    // tslint:disable-next-line: prefer-const
    let applicationUser = JSON.parse(localStorage.getItem('currentUser'));
    this.UserFullName = applicationUser.FirstName + ' ' + applicationUser.LastName;
    this.ProfileImageUrl = applicationUser.ImageUrl == null ? '/assets/images/default-avatar.png' : applicationUser.ImageUrl;
  }
}
